import React from "react";
import { SliceStopCountFilter } from "redmond";
import clsx from "clsx";

import "./styles.scss";
import * as textConstants from "./textConstants";
import { ButtonWrap, Icon, IconName, RadioDropdown } from "halifax";
import { Box } from "@material-ui/core";
import { initialFilterOptions } from "../../../../reducer";

interface IStopsOptionSelectionProps {
  stopsOption: SliceStopCountFilter;
  setStopsOption: (stopsOption: SliceStopCountFilter) => void;
  hasSetStopsOption?: boolean;
  setRerunPrediction?: () => void;
  showDropdownContentOnly?: boolean;
  appliedLabel?: string;
  icon?: IconName;
  title?: string;
  radioLabelPlacement?: "start" | "end";
}

export const StopsOptionSelection = (props: IStopsOptionSelectionProps) => {
  const {
    stopsOption,
    setStopsOption,
    setRerunPrediction,
    showDropdownContentOnly,
    hasSetStopsOption,
    appliedLabel,
    icon,
    title,
    radioLabelPlacement,
  } = props;

  const handleChange = (value: string) => {
    setStopsOption(value as SliceStopCountFilter);
    if (!!setRerunPrediction) {
      setRerunPrediction();
    }
  };

  return (
    <Box className="pkg-flight-shop-stops-filter-container" tabIndex={0}>
      {!!title && showDropdownContentOnly && (
        <Box className="header-container">
          {icon && <Icon name={icon} />} {title}
        </Box>
      )}
      <RadioDropdown
        dropdownLabel={textConstants.STOPS_HEADER_TEXT(
          hasSetStopsOption ? appliedLabel : undefined
        )}
        options={stopsOptions}
        setOption={handleChange}
        selected={stopsOption}
        showDropdownContentOnly={showDropdownContentOnly}
        buttonClassName={clsx("b2b-shop-filter", {
          "has-value": hasSetStopsOption,
        })}
        groupAriaLabel={textConstants.CHOOSE_STOPS_OPTION_TEXT}
        buttonAriaLabel={textConstants.CHANGE_STOPS_OPTION_TEXT}
        popoverClassName={clsx(
          "b2b",
          "flight-availability-stops-popover",
          "filter-experiment"
        )}
        dropdownIcon={
          hasSetStopsOption && appliedLabel ? (
            <ButtonWrap
              onClick={(e) => {
                e.stopPropagation();
                handleChange(initialFilterOptions.stopsOption);
              }}
            >
              <Icon name={IconName.XCircle} />
            </ButtonWrap>
          ) : undefined
        }
        anchorOrigin={(() => {
          return {
            vertical: "bottom",
            horizontal: "left",
          };
        })()}
        transformOrigin={(() => {
          return {
            vertical: "top",
            horizontal: "left",
          };
        })()}
        radioLabelPlacement={radioLabelPlacement}
      />
    </Box>
  );
};

interface IStopsOption {
  label: string;
  value: SliceStopCountFilter;
}

const stopsOptions: IStopsOption[] = [
  {
    label: textConstants.ANY_NUMBER_OF_STOPS_TEXT,
    value: SliceStopCountFilter.ANY_NUMBER,
  },
  {
    label: textConstants.NO_STOPS_ONLY,
    value: SliceStopCountFilter.NONE,
  },
  {
    label: textConstants.ONE_STOP_OR_FEWER,
    value: SliceStopCountFilter.ONE_OR_LESS,
  },
  {
    label: textConstants.TWO_STOPS_OR_FEWER,
    value: SliceStopCountFilter.TWO_OR_LESS,
  },
];
